module.exports = __webpack_public_path__ + "media/social/social-2-f10554d0.png";